/* ==========================================================================
   OUTER LIMITS — THEME BEHAVIOURS (Horizon edition)
   Charles Consulting
   --------------------------------------------------------------------------
   Small, dependency-free progressive enhancement for the Outer Limits
   sections. Everything works without JavaScript; this adds:

     1. Scroll reveal          .ol-reveal → .is-in
     2. Tabs                   [data-ol-tabs]   (service menu, filter grids)
     3. Accordion              .ol-acc__btn
     4. Booking form           [data-ol-booking] slot picker + validation
     5. Hours                  today highlight + open-now status
     6. Add to cart            [data-ol-add] via Shopify.actions (Horizon's
                               cart drawer opens), with an AJAX fallback
     7. Bicycle-wheel cursor   fine pointers only, respects reduced motion
     8. Theme-editor hooks     re-init on section load, reveal selected blocks
   ========================================================================== */
(function () {
  'use strict';

  var OL = (window.OLTheme = window.OLTheme || {});
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  function up(target, selector) {
    var el = target;
    while (el && el.nodeType !== 1) el = el.parentNode;
    return el && el.closest ? el.closest(selector) : null;
  }

  /* ---------------------------------------------------------------- 1 REVEAL */
  var io = null;
  function initReveal(scope) {
    var nodes = (scope || document).querySelectorAll('.ol-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce || !document.documentElement.classList.contains('ol-reveal-on')) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ------------------------------------------------------------------ 2 TABS */
  function selectTab(tab) {
    var group = tab.closest('[data-ol-tabs]');
    if (!group) return;
    var tabs = group.querySelectorAll('[data-ol-tab]');
    var target = tab.getAttribute('data-ol-tab');
    tabs.forEach(function (t) {
      if (t.closest('[data-ol-tabs]') !== group) return;
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    group.querySelectorAll('[data-ol-panel]').forEach(function (p) {
      if (p.closest('[data-ol-tabs]') !== group) return;
      var on = p.getAttribute('data-ol-panel') === target;
      p.classList.toggle('is-active', on);
      p.hidden = !on;
      if (on) initReveal(p);
    });
  }
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-ol-tabs]').forEach(function (group) {
      var tabs = group.querySelectorAll('[data-ol-tab]');
      if (!tabs.length) return;
      var current = group.querySelector('[data-ol-tab][aria-selected="true"]') || tabs[0];
      group.setAttribute('data-ol-tabs-ready', '');
      selectTab(current);
    });
  }
  document.addEventListener('click', function (e) {
    var tab = up(e.target, '[data-ol-tab]');
    if (tab) { e.preventDefault(); selectTab(tab); }
  });
  document.addEventListener('keydown', function (e) {
    var tab = up(e.target, '[data-ol-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var group = tab.closest('[data-ol-tabs]');
    var list = Array.prototype.filter.call(group.querySelectorAll('[data-ol-tab]'), function (t) { return t.closest('[data-ol-tabs]') === group; });
    var i = list.indexOf(tab);
    var next = list[(i + (e.key === 'ArrowRight' ? 1 : -1) + list.length) % list.length];
    next.focus(); selectTab(next); e.preventDefault();
  });


  /* ------------------------------------------------------------ 2b FILTERS
     Model grids: buttons [data-ol-filter] show only cards whose
     data-ol-cat list contains the chosen slug ("all" shows everything). */
  document.addEventListener('click', function (e) {
    var btn = up(e.target, '[data-ol-filter]');
    if (!btn) return;
    e.preventDefault();
    var group = btn.closest('[data-ol-filter-group]');
    if (!group) return;
    var val = btn.getAttribute('data-ol-filter');
    group.querySelectorAll('[data-ol-filter]').forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
    group.querySelectorAll('[data-ol-cat]').forEach(function (card) {
      var cats = (' ' + card.getAttribute('data-ol-cat') + ' ');
      var show = val === 'all' || cats.indexOf(' ' + val + ' ') > -1;
      card.hidden = !show;
      if (show) { var r = card.querySelector('.ol-reveal'); if (r) r.classList.add('is-in'); }
    });
  });

  /* ------------------------------------------------------------- 3 ACCORDION */
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var btn = item.querySelector('.ol-acc__btn');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var btn = up(e.target, '.ol-acc__btn');
    if (!btn) return;
    var item = btn.closest('.ol-acc__item');
    var acc = btn.closest('.ol-acc');
    var open = !item.classList.contains('is-open');
    if (open && acc && acc.hasAttribute('data-ol-single')) {
      acc.querySelectorAll('.ol-acc__item.is-open').forEach(function (i) { if (i !== item) setOpen(i, false); });
    }
    setOpen(item, open);
  });

  /* ---------------------------------------------------------- 4 BOOKING FORM */
  function initBooking(scope) {
    (scope || document).querySelectorAll('[data-ol-booking]').forEach(function (form) {
      if (form.__olBound) return;
      form.__olBound = true;
      var slotInput = form.querySelector('[data-ol-slot-input]');
      var dateInput = form.querySelector('input[type="date"]');
      if (dateInput && !dateInput.min) {
        var d = new Date();
        dateInput.min = d.toISOString().slice(0, 10);
      }
      form.addEventListener('click', function (e) {
        var slot = up(e.target, '.ol-slot');
        if (!slot) return;
        form.querySelectorAll('.ol-slot').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        slot.setAttribute('aria-pressed', 'true');
        if (slotInput) slotInput.value = slot.textContent.trim();
      });
      form.addEventListener('submit', function (e) {
        var out = form.querySelector('[data-ol-booking-result]');
        var needsSlot = form.getAttribute('data-ol-require-slot') === 'true' && form.querySelector('.ol-slot');
        var errors = [];
        if (needsSlot && slotInput && !slotInput.value) errors.push(form.getAttribute('data-msg-slot') || 'Pick a time to continue.');
        form.querySelectorAll('[required]').forEach(function (f) {
          if (!f.value || (f.type === 'email' && !/.+@.+\..+/.test(f.value))) errors.push((f.getAttribute('data-label') || f.name) + ' is required.');
        });
        if (errors.length) {
          e.preventDefault();
          if (out) {
            out.hidden = false;
            out.classList.add('ol-booking__result--error');
            out.innerHTML = '<b>' + errors[0] + '</b>';
            out.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
          }
          return;
        }
        /* Build a readable summary into the message body the shop receives. */
        var body = form.querySelector('[name="contact[body]"]');
        if (body && body.type === 'hidden') {
          var lines = [];
          form.querySelectorAll('[data-ol-summary]').forEach(function (f) {
            var v = f.tagName === 'SELECT' ? f.options[f.selectedIndex].text : f.value;
            if (v) lines.push(f.getAttribute('data-ol-summary') + ': ' + v);
          });
          body.value = lines.join('\n');
        }
      });
    });
  }

  /* ----------------------------------------------------------------- 5 HOURS */
  function toMin(hhmm) {
    var m = /^(\d{1,2}):?(\d{2})$/.exec(String(hhmm || '').trim());
    return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null;
  }
  function initHours(scope) {
    var now = new Date();
    var day = now.getDay(); /* 0 = Sunday */
    var mins = now.getHours() * 60 + now.getMinutes();
    (scope || document).querySelectorAll('[data-ol-hours]').forEach(function (list) {
      var today = list.querySelector('li[data-day="' + day + '"]');
      if (today) today.classList.add('is-today');
      var status = list.parentNode.querySelector('[data-ol-open-status]');
      if (status && today) {
        var o = toMin(today.getAttribute('data-open'));
        var c = toMin(today.getAttribute('data-close'));
        if (o !== null && c !== null) {
          var open = mins >= o && mins < c;
          status.hidden = false;
          status.setAttribute('data-open', open ? 'true' : 'false');
          status.textContent = open ? 'Open now' : 'Closed now';
        }
      }
    });
  }

  /* ----------------------------------------------------------- 6 ADD TO CART */
  document.addEventListener('click', function (e) {
    var btn = up(e.target, '[data-ol-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-ol-add');
    var label = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = (OL.strings && OL.strings.adding) || 'Adding…';
    var done = function () {
      btn.textContent = (OL.strings && OL.strings.added) || 'Added';
      setTimeout(function () { btn.textContent = label; btn.removeAttribute('aria-disabled'); }, 1600);
    };
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      actions.updateCart({ lines: [{ merchandiseId: id, quantity: 1 }] }, { event: { context: 'product' } })
        .then(function (res) {
          if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
          done();
          if (actions.openCart) actions.openCart();
        })
        .catch(function () { window.location.href = (OL.cartUrl || '/cart'); });
      return;
    }
    fetch((OL.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = OL.cartUrl || '/cart';
    }).catch(function () { btn.textContent = label; btn.removeAttribute('aria-disabled'); });
  });

  /* ---------------------------------------------------------------- 7 CURSOR
     Spinning bicycle wheel. Activates on the first real mouse movement
     (pointerType "mouse"), so it works on touchscreen laptops too and never
     appears for finger or pen input. Works in the theme editor preview.
     Hands back the native pointer over dialogs (cart drawer, search) and
     embedded iframes (maps, booking widgets), which draw above any page
     element and would otherwise hide it. */
  function initCursor() {
    if (!OL.cursor || OL.__cursor) return;
    OL.__cursor = true;
    var el = null, wheel = null, active = false, shown = false;
    var lastX = 0, lastY = 0, angle = 0, vel = 0, running = false;

    function build() {
      el = document.createElement('div');
      el.className = 'ol-cursor';
      el.setAttribute('aria-hidden', 'true');
      var knobs = '', spokes = '';
      for (var a = 0; a < 360; a += 30) knobs += '<rect class="knob" x="18.3" y="2.4" width="3.4" height="4.1" rx="1" transform="rotate(' + a + ' 20 20)"/>';
      for (var b = 0; b < 360; b += 60) spokes += '<line class="spoke" x1="20" y1="20" x2="20" y2="10.2" transform="rotate(' + b + ' 20 20)"/>';
      el.innerHTML = '<svg viewBox="0 0 40 40" width="34" height="34"><g class="ol-cursor-wheel">' +
        '<circle class="tire" cx="20" cy="20" r="16.3"/><g>' + knobs + '</g>' +
        '<circle class="rim" cx="20" cy="20" r="9.8"/><g>' + spokes + '</g>' +
        '<circle class="hub" cx="20" cy="20" r="2.5"/></g></svg>';
      document.body.appendChild(el);
      wheel = el.querySelector('.ol-cursor-wheel');
    }
    function setActive(on) {
      if (on === active) return;
      active = on;
      document.body.classList.toggle('has-ol-cursor', on);
      if (el) el.style.opacity = on && shown ? '1' : '0';
    }
    function spin() {
      if (!reduce && wheel) {
        angle = (angle + vel) % 360;
        vel *= 0.9;
        if (Math.abs(vel) < 0.02) vel = 0;
        wheel.setAttribute('transform', 'rotate(' + angle.toFixed(2) + ' 20 20)');
      }
      if (vel !== 0) requestAnimationFrame(spin); else running = false;
    }
    function overlayOpen() {
      try { return !!document.querySelector('dialog[open], [popover]:popover-open, .shopify-section-group-overlay-group [open]'); }
      catch (e) { return !!document.querySelector('dialog[open]'); }
    }

    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') { setActive(false); return; }
      if (!el) build();
      var x = e.clientX, y = e.clientY;
      if (!shown) { shown = true; lastX = x; lastY = y; }
      if (overlayOpen() || (e.target && e.target.tagName === 'IFRAME')) { setActive(false); return; }
      setActive(true);
      el.style.opacity = '1';
      var dx = x - lastX, dy = y - lastY;
      if (!reduce) vel += Math.min(Math.sqrt(dx * dx + dy * dy) * 0.85, 26);
      lastX = x; lastY = y;
      el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      var t = e.target && e.target.closest && e.target.closest('button, a, [role="button"], label, summary, select, .ol-btn, .ol-brand, .ol-slot, .ol-tab, .ol-chip');
      el.classList.toggle('is-hover', !!t);
      if (!running && vel > 0) { running = true; requestAnimationFrame(spin); }
    }, { passive: true });
    document.addEventListener('pointerdown', function (e) { if (el && e.pointerType === 'mouse') el.classList.add('is-down'); });
    document.addEventListener('pointerup', function () { if (el) el.classList.remove('is-down'); });
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && el) el.style.opacity = '0'; });
    window.addEventListener('blur', function () { if (el) el.style.opacity = '0'; });
  }

  /* ------------------------------------------------------------------- BOOT */
  function init(scope) {
    initTabs(scope);
    initBooking(scope);
    initHours(scope);
    initReveal(scope);
  }

  function boot() {
    init(document);
    initCursor();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* -------------------------------------------------------- 8 EDITOR HOOKS */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    var panel = block.closest && block.closest('[data-ol-panel]');
    if (panel) {
      var group = panel.closest('[data-ol-tabs]');
      var tab = group && group.querySelector('[data-ol-tab="' + panel.getAttribute('data-ol-panel') + '"]');
      if (tab) selectTab(tab);
    }
    if (block.matches && block.matches('[data-ol-panel]')) {
      var g = block.closest('[data-ol-tabs]');
      var t = g && g.querySelector('[data-ol-tab="' + block.getAttribute('data-ol-panel') + '"]');
      if (t) selectTab(t);
    }
    var item = block.classList && block.classList.contains('ol-acc__item') ? block : (block.querySelector && block.querySelector('.ol-acc__item'));
    if (item) setOpen(item, true);
    initReveal(block.parentNode || document);
  });
})();
